import { Injectable } from '@angular/core';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class MechanicService {
  constructor (
    private apiService: ApiService
  ) {}

  check ( mechanic : any ) : ng.IPromise<any> {
    return this.apiService.get('/mechanic/has_event_times', mechanic.id);
  }

  checkMechanicCode ( oldCode : string | number, newCode : string | number) : ng.IPromise<any> {
    return oldCode !== newCode
      ? this.apiService.post('/mechanics/verify_mechanic_code_uniqueness', {
          mechanic_code: newCode
        })
      : Promise.resolve(true);
  }
}
